/**
 * @typedef {Object} MessageBoxOptions
 * @property {string?} title タイトル
 * @property {string?} message メッセージ
 * @property {string?} okButtonName OKボタンタイトル
 * @property {string?} cancelButtonName CANCELボタンタイトル
 * @property {boolean} persistent ダイアログの外側をクリックしたときにダイアログを閉じるか
 */

const defaultOptions = () => {
	return {
		title: "",
		messages: [],
		okButtonName: "OK",
		cancelButtonName: "CANCEL",
		persistent: false,
		showTitle: false,
		noCancel: false
	}
}

/**
	* メッセージボックス部品
	*/
export default class MessageBox {
	// /**
	//  * コンストラクタ
	//  * @param {MessageBoxOptions} options 表示オプション
	//  */
	// constructor (options) {
	// 	this.#options = {
	// 		...this.#options,
	// 		...options
	// 	}
	// }

	/**
	 * 確認メッセージ表示処理
	 */
	showConfirmMessageBox (argOptions) {
		/** @type {MessageBoxOptions} 表示オプション */
		const options = {
			...defaultOptions(),
			...argOptions
		}
		if (options.message) {
			options.messages = options.message.split(/<br\/?>/g)
		}

		return new Promise(resolve => {
			let messageBox = ""
			let persistent = ""
			let header = ""

			// 維持フラグ設定
			if (options.persistent) {
				persistent = "persistent"
			}

			// タイトル表示設定
			if (!options.showTitle) {
				header = "no-header"
			}

			// 確認メッセージ
			messageBox = /* html */`
				<bui-dialog id="messageBox" dialog-title="${options.title}" no-close-icon ${persistent} ${header} has-actions>
					<div class="messagebox-content">
					</div>
					<div slot="actions">
						${options.noCancel ? "" : `<button is="bui-button" class="bui-button is-error is-text cancel-btn" text>${options.cancelButtonName}</button>`}
						<button is="bui-button" class="bui-button is-primary is-text ok-btn">${options.okButtonName}</button>
					</div>
				</bui-dialog>
			`
			const template = document.createElement("template")
			template.innerHTML = messageBox
			const messageBoxEl = template.content
			const content = messageBoxEl.querySelector(".messagebox-content")
			options.messages.forEach(message => {
				const el = document.createElement("div")
				el.textContent = message
				content.appendChild(el)
			})
			this.#createMessageBox(resolve, messageBoxEl)
		})
	}

	/**
	 * エラーメッセージ表示処理
	 */
	showErrorMessageBox (argOptions) {
		/** @type {MessageBoxOptions} 表示オプション */
		const options = {
			...defaultOptions(),
			...argOptions
		}

		if (options.message) {
			options.messages = options.message.split(/<br\/?>/g)
		}

		return new Promise(resolve => {
			let messageBox = ""
			let persistent = ""
			let header = ""

			// 維持フラグ設定
			if (options.persistent) {
				persistent = "persistent"
			}

			// タイトル表示設定
			if (!options.showTitle) {
				header = "no-header"
			}

			// エラーメッセージ
			messageBox = /* html */`
				<bui-dialog id="messageBox" dialog-title="${options.title}" no-close-icon ${persistent} ${header} has-actions>
					<div class="messagebox-content">
					</div>
					<div slot="actions">
						<button is="bui-button" class="bui-button is-error is-text ok-btn" text>${options.okButtonName}</button>
					</div>
				</bui-dialog>
			`

			const template = document.createElement("template")
			template.innerHTML = messageBox
			const messageBoxEl = template.content
			const content = messageBoxEl.querySelector(".messagebox-content")
			options.messages.forEach(message => {
				const el = document.createElement("div")
				el.textContent = message
				content.appendChild(el)
			})
			this.#createMessageBox(resolve, messageBoxEl)
		})
	}

	/**
	 * イベント生成処理
	 * @param {(value?: any) => void} resolve
	 * @param {HTMLElement?} messageBox
	 */
	#createMessageBox (resolve, messageBox) {
		const dialog = messageBox.querySelector("bui-dialog")

		// OKボタンクリック
		dialog.querySelector(".ok-btn").addEventListener("click", () => {
			resolve({
				ok: true
			})
			dialog.close()
		})

		// キャンセルボタンクリック
		const cancelBtn = dialog.querySelector(".cancel-btn")

		if (cancelBtn !== null) {
			cancelBtn.addEventListener("click", () => {
				resolve({
					ok: false
				})
				dialog.close()
			})
		}

		// メッセージボックス閉じるとき
		dialog.addEventListener("modal-afterhide", () => {
			dialog.remove()
		})

		document.body.appendChild(messageBox)

		dialog.updateComplete.then(() => {
			dialog.open()
		})
	}
}
